var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentLogoDhl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 40,
    viewBox: "0 0 80 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6616 15L14.3613 18.1255H26.898C27.532 18.1255 27.5241 18.3642 27.2142 18.7863C26.8996 19.2132 26.3731 19.9514 26.0522 20.3862C25.8894 20.6059 25.5953 21.0059 26.5692 21.0059H31.6961L33.2154 18.9412C34.1576 17.6623 33.2976 15.0016 29.9286 15.0016L16.6616 15Z",
    fill: "#D80613"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4302 25.1828L18.0512 18.9033H23.7853C24.4192 18.9033 24.4113 19.1436 24.1014 19.5641L22.9316 21.1577C22.7687 21.3775 22.4747 21.7775 23.4485 21.7775H31.1286C30.4915 22.6533 28.4174 25.1828 24.699 25.1828H13.4302ZM39.8917 21.7759L37.3859 25.1828H30.7761L33.2819 21.7759H39.8917ZM50.0159 21.0044H33.851L38.2713 15H44.8779L42.3453 18.4433H45.2937L47.8295 15H54.4362L50.0159 21.0044ZM49.4484 21.7759L46.9426 25.1828H40.3359L42.8417 21.7759H49.4484ZM4 23.1197H13.7353L13.2041 23.8422H4V23.1197ZM4 21.7759H14.725L14.1922 22.4984H4V21.7759ZM4 24.4635H12.7473L12.2176 25.1828H4V24.4635ZM76 23.8422H66.2995L66.8322 23.1197H76V23.8422ZM76 25.1828H65.3145L65.8426 24.4635H76V25.1828ZM67.8203 21.7759H76V22.4999H67.2891L67.8203 21.7759ZM63.5866 15L59.1663 21.0044H52.1644L56.5878 15H63.5866ZM51.5984 21.7759C51.5984 21.7759 51.1163 22.4367 50.8807 22.7529C50.0523 23.8753 50.7843 25.1812 53.4924 25.1812H64.1036L66.6093 21.7759H51.5984Z",
    fill: "#D80613"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentLogoDhl);
export default __webpack_public_path__ + "static/media/payment-logo-dhl.c8d6e3c7325e74fabdab2680b355366a.svg";
export { ForwardRef as ReactComponent };